(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tt-product-card"] && !Shopify.designMode) return;
  try {
    if (!window.toyToyQuickAddReady) {
  window.toyToyQuickAddReady = true;
  let cartQueue = Promise.resolve();
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('.tt-quick-add')) return;
    event.preventDefault();
    if (form.dataset.busy === 'true') return;
    const button = form.querySelector('button[type="submit"]');
    const status = form.closest('.tt-product-card').querySelector('.tt-card-status');
    const label = button.textContent;
    const accessibleLabel = button.getAttribute('aria-label');
    form.dataset.busy = 'true';
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = form.dataset.adding;
    status.textContent = '';
    status.classList.remove('tt-card-error');
    const add = async () => {
      let added = false;
      try {
        const response = await fetch(form.action + '.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: new FormData(form)
        });
        const result = await response.json();
        if (!response.ok || result.status) {
          throw new Error(typeof result.description === 'string' ? result.description : form.dataset.error);
        }
        added = true;
        button.textContent = form.dataset.added;
        button.setAttribute('aria-label', form.dataset.addedLabel);
        status.textContent = form.dataset.addedLabel;
        try {
          const cartResponse = await fetch(form.dataset.cartUrl + '.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' });
          if (cartResponse.ok) {
            const cart = await cartResponse.json();
            document.querySelectorAll('[data-cart-count]').forEach((count) => { count.textContent = cart.item_count; });
          }
        } catch {}
      } catch (error) {
        button.textContent = label;
        status.textContent = error.message || form.dataset.error;
        status.classList.add('tt-card-error');
      } finally {
        button.removeAttribute('aria-busy');
        const reset = () => {
          button.disabled = false;
          button.textContent = label;
          button.setAttribute('aria-label', accessibleLabel);
          delete form.dataset.busy;
        };
        if (added) window.setTimeout(reset, 2000);
        else reset();
      }
    };
    cartQueue = cartQueue.then(add, add);
  });
}
  } catch(e) { console.error(e); }
})();

})();
